import React from 'react';
import { createPortal } from 'react-dom';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Shared "Start Scoring?" confirm — same title, team-names line, sole-scorer
 * wording, and Cancel/Start Scoring buttons everywhere a user is about to
 * claim a match (the schedule list's row badge, and the fullscreen detail
 * panel's Prev/Next view). Originally lived inline in MatchRow.jsx; pulled
 * out so both places show byte-for-byte the same confirmation instead of two
 * screens that drift out of sync.
 */
const StartScoringConfirmModal = ({ isOpen, onClose, row, isStarting, onConfirm }) => {
  const { theme } = useTheme();

  if (!isOpen) return null;

  return createPortal(
    <div onClick={(e) => e.stopPropagation()}>
      <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50">
        <div className={`${theme.card} rounded-2xl border ${theme.border} p-6 max-w-sm w-full shadow-xl`}>
          <h3 className={`text-lg font-bold ${theme.text} mb-2`}>Start Scoring?</h3>
          <p className={`text-sm ${theme.textMuted} mb-1`}>
            <span className="font-medium">{row.liveData?.participant_a_name || row.slotA?.name || 'Team A'}</span>
            {' vs '}
            <span className="font-medium">{row.liveData?.participant_b_name || row.slotB?.name || 'Team B'}</span>
          </p>
          <p className={`text-sm ${theme.textMuted} mb-6`}>
            You will be the sole scorer for this match. Other users will see a read-only view until the game is finished.
          </p>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={isStarting}
              className={`flex-1 py-2 rounded-xl border ${theme.border} ${theme.text} text-sm font-medium disabled:opacity-50`}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isStarting}
              className={`flex-1 rounded-xl px-4 py-2 text-sm font-semibold transition-colors ${theme.buttonPrimary} hover:opacity-90 disabled:opacity-60`}
            >
              {isStarting ? 'Starting…' : 'Start Scoring'}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default StartScoringConfirmModal;
